module.exports = __webpack_public_path__ + "img/logo.c40d25da.svg";